"use client";
import React from "react";
import { MobileHeader } from "../MobileHeader";
import AnalyticsHeader from "../AnalyticsHeader";
import TotalUsageSection from "../TotalUsageSection";
import UsageBreakdownSection from "../UsageBreakdownSection";
import { TabBar } from "../TabBar";

const AnalyticsDashboard: React.FC = () => {
  return (
    <main className="pb-96 mx-auto w-full max-w-[480px]">
      <section className="overflow-hidden pb-24 w-full bg-white min-h-[1202px]">
        <MobileHeader />
        <section className="pt-8 w-full h-[748px]">
          <AnalyticsHeader />
          <div className="pb-24 mt-8 w-full">
            <div className="px-4 w-full">
              <TotalUsageSection />
              <UsageBreakdownSection />
            </div>
          </div>
        </section>
      </section>
      <TabBar />
    </main>
  );
};

export default AnalyticsDashboard;
